var _excluded = ["breadcrumbs", "className"],
  _excluded2 = ["title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import { arrayOf, node, shape, string } from "prop-types";
import React from "react";
import { Link } from "#library/components/Link/Link";
import { Text, TEXT_TYPES } from "#library/components/Text/Text";
import styles from "./BreadcrumbTrail.module.css";
var BreadcrumbTrail = function BreadcrumbTrail(_ref) {
  var breadcrumbs = _ref.breadcrumbs,
    className = _ref.className,
    restProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("nav", _extends({
    className: className
  }, restProps), /*#__PURE__*/React.createElement("ol", {
    className: styles["jds-BreadcrumbTrail__list"]
  }, breadcrumbs.map(function (_ref2, index) {
    var title = _ref2.title,
      itemRestProps = _objectWithoutProperties(_ref2, _excluded2);
    var itemContent = null;
    if (index === breadcrumbs.length - 1) {
      itemContent = /*#__PURE__*/React.createElement(Text, {
        tag: "span",
        type: TEXT_TYPES.SMALL
      }, title);
    } else {
      itemContent = /*#__PURE__*/React.createElement(Link, _extends({
        className: styles["jds-BreadcrumbTrail__link"],
        minor: true
      }, itemRestProps), title);
    }
    return /*#__PURE__*/React.createElement("li", {
      key: title,
      className: styles["jds-BreadcrumbTrail__item"]
    }, itemContent);
  })));
};
BreadcrumbTrail.propTypes = {
  breadcrumbs: arrayOf(shape({
    title: node.isRequired
  })).isRequired,
  className: string
};
export { BreadcrumbTrail };